import React, { useState } from 'react'
import styled from 'styled'

import { Content, Container, Wrap, DragHandle } from 'components/ui/draggable'
import { IconParagraph } from 'components/ui/icons'
import { Title } from 'components/ui/list-item-label'
import { PopOverMenu, PopOverMenuButton } from 'components/ui/pop-over-menu'

import { space } from 'helpers/style'

import { Amenity } from 'generated/mos/org/getty/visitorinfo'

import { amenitySchema } from '../../schemas/visitorInfo'


const Icon = styled(IconParagraph)`
  margin-right: ${space(3)};
`

type Props = {
  readonly draggableIndex?: number | undefined;
  readonly amenity: Amenity.Entity;
  readonly deleteHandler: (amenity: Amenity.Entity) => void;
  readonly updateHandler: (amenity: Amenity.Entity) => void;
  readonly isDragging?: boolean;
}

export const AmenityItem = ({ draggableIndex, amenity, deleteHandler, updateHandler, isDragging }: Props) => {
  const [showAmenities, setShowAmenities] = useState<boolean>(true)
  return (
    <Container isDragging={isDragging}>
      <Wrap isDragging={isDragging}>
        {draggableIndex !== undefined && <DragHandle />}
        <Content onClick={() => setShowAmenities(!showAmenities)}>
          <Icon size="medium" />
          <Title>{amenitySchema.name.read(amenity.name) || 'no title'}</Title>
        </Content>
        <PopOverMenu iconSize="base">
          <PopOverMenuButton
            onClick={() => updateHandler(amenity)}
            >
              Edit
          </PopOverMenuButton>
          <PopOverMenuButton
            onClick={() => deleteHandler(amenity)}
            >
              Delete
          </PopOverMenuButton>
        </PopOverMenu>
      </Wrap>
    </Container>
  )
}
